import { useLocation, useOutletContext } from 'react-router-dom';
import { findMatchingRoute, canAccessRoute } from '../utils/routePermissions';
import type { AppLayoutContext } from '../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const context = useOutletContext<AppLayoutContext | null>();
  const roleContext = context?.roleContext;

  if (!roleContext) {
    return <div>Loading...</div>;
  }

  const routePattern = findMatchingRoute(location.pathname);

  if (!routePattern) {
    return (
      <div className="p-8">
        <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
        <p>You do not have permission to access this page.</p>
      </div>
    );
  }

  const canAccess = canAccessRoute(routePattern, roleContext.selectedRole ?? '');

  if (!canAccess) {
    return (
      <div className="p-8">
        <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
        <p>You do not have permission to access this page.</p>
        <p className="text-sm text-gray-600 mt-2">
          Required role: {routePattern} requires one of the following roles
        </p>
      </div>
    );
  }

  return <>{children}</>;
}

export default ProtectedRoute;
